import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div><div class=\"mb-10\"><svg width=\"88\" height=\"6\" viewBox=\"0 0 88 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"26\" height=\"6\" fill=\"#D4315C\"></rect><rect x=\"31\" width=\"26\" height=\"6\" fill=\"#6FA3AF\"></rect><rect x=\"62\" width=\"26\" height=\"6\" fill=\"#F2C152\"></rect></svg></div><h1>For the next few questions, please choose the option you find easiest to read.</h1></div>", 1)
const _hoisted_2 = { class: "flex justify-between mt-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.2299 1.24994L11.2299 14.7499C11.2295 14.8866 11.1918 15.0206 11.1209 15.1374C11.05 15.2543 10.9486 15.3496 10.8275 15.4131C10.7065 15.4766 10.5704 15.5059 10.434 15.4978C10.2975 15.4897 10.1659 15.4445 10.0532 15.3672L0.303188 8.61719C-0.101062 8.33744 -0.101062 7.66394 0.303188 7.38344L10.0532 0.633442C10.1656 0.55531 10.2974 0.509492 10.434 0.500965C10.5707 0.492439 10.7071 0.521529 10.8284 0.585077C10.9497 0.648625 11.0513 0.744198 11.122 0.861415C11.1928 0.978631 11.2302 1.11301 11.2299 1.24994Z",
    fill: "black"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.750044 1.24994L0.750043 14.7499C0.750471 14.8866 0.788168 15.0206 0.859077 15.1374C0.929984 15.2543 1.03142 15.3496 1.15246 15.4131C1.2735 15.4766 1.40956 15.5059 1.546 15.4978C1.68245 15.4897 1.8141 15.4445 1.92679 15.3672L11.6768 8.61719C12.081 8.33744 12.081 7.66394 11.6768 7.38344L1.92679 0.633442C1.81434 0.55531 1.68262 0.509492 1.54595 0.500965C1.40928 0.492439 1.27289 0.521529 1.15159 0.585077C1.03029 0.648625 0.928728 0.744198 0.857935 0.861415C0.787143 0.978631 0.749827 1.11301 0.750044 1.24994Z",
    fill: "white"
  })
], -1)


import Logo from './Logo.vue';
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionsCover',
  emits: ["previousPage", "nextPage"],
  setup(__props, { emit }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SecondaryButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('previousPage')))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Back ")
        ]),
        _: 1
      }),
      _createVNode(PrimaryButton, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('nextPage')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Next "),
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}
}

})